module.exports = __webpack_public_path__ + "static/media/schedule-mobile.6d131a79.svg";